import React, { useMemo } from 'react';
import forms from 'constants/forms';
import Note from 'components/atoms/icons/noteIcon';
import PhoneCall from 'components/atoms/icons/phoneCallIcon';
import Sms from 'components/atoms/icons/smsSimpleIcon';
import ICD from 'components/atoms/icons/icdCodeIcon';
import { PropTypes } from 'prop-types';

const ACTIVITY_NOTE = forms.ccmPatientActivities[0];
const ACTIVITY_SMS = forms.ccmPatientActivities[1];
const ACTIVITY_CALL = forms.ccmPatientActivities[2];
const ACTIVITY_ICD = forms.ccmPatientActivities[3];
const ACTIVITY_TYPES = {
  [ACTIVITY_NOTE.id]: { icon: <Note />, label: ACTIVITY_NOTE.label },
  [ACTIVITY_ICD.id]: { icon: <ICD />, label: ACTIVITY_ICD.label },
  [ACTIVITY_SMS.id]: { icon: <Sms />, label: ACTIVITY_SMS.label },
  [ACTIVITY_CALL.id]: { icon: <PhoneCall />, label: ACTIVITY_CALL.label },
};
const activityByType = (type) => {
  if (!ACTIVITY_TYPES[type])
    return { icon: <PhoneCall />, label: ACTIVITY_CALL.label };
  return ACTIVITY_TYPES[type];
};
const Activity = ({ actionType }) => {
  const activity = useMemo(() => activityByType(actionType));
  return (
    <>
      <span className="ccm-activity-row__activity-icon">{activity?.icon}</span>

      <span>{activity?.label}</span>
    </>
  );
};

Activity.propTypes = {
  actionType: PropTypes.string.isRequired,
};

export default Activity;
